<template>
  <div v-if="!loading" class="col-12 flex no-box px1 py2 items-center flex-column white-bg">
    <div class="flex col-12 px0 align-middle" @click="hasPromoCode = !hasPromoCode">
      <div class="mr1">
        <input v-model="hasPromoCode" type="checkbox" class="pointer">
      </div>
      <label class="h5 self-center">J’ai un code promotionnel (hors carte cadeau : à saisir à la prochaine étape sur la page de paiement)</label>
    </div>
    <div class="flex col-12 px1">
      <form v-if="hasPromoCode" class="flex flex-column flex-grow" @submit.prevent="submitPromoCode">
        <div class="flex justify-center">
          <div v-if="codeValid" class="flex mb1 green">Code appliqué</div>
          <div v-if="message" class="flex mb1 red">{{ message }}</div>
        </div>
        <div class="flex col-12 pr1 flex-grow mt1">
          <input v-model="promoCode" type="text" placeholder="Code promotionnel" class="h5n flex-grow p2">
          <button
            type="submit"
            class="no-wrap h5n transparent-bg p2 invert border-none bold"
          >
            Valider
          </button>
        </div>
      </form>
    </div>
  </div>
  <div v-else class="flex white-bg p2 justify-center items-center">
    <div class="spinner"></div>
  </div>
</template>

<script>
import { submitPromoCode } from '@/utils/requests';

export default {
  data () {
    return {
      loading: false,
      promoCode: '',
      productUuid: this.$store.state.product?.uuid,
      horanetProductCode: this.$store.state.offerInfo?.horanet_product?.horanet_product_code || this.$store.state.offerInfo?.uuid,
      workspace: this.$store.getters.workspace,
      codeValid: false,
      message: null,
      promoCampaign: this.$store.state.promoCampaign,
      hasPromoCode: false
    };
  },
  methods: {
    async submitPromoCode () {
      this.loading = true;
      this.message = null;
      await submitPromoCode({ workspace: this.workspace, promoCode: this.promoCode, productUuid: this.productUuid, horanetProductCode: this.horanetProductCode }).then(r => {
        this.codeValid = r.success;

        if (!r.success || !r.data) {
          this.message = r.message || 'Code invalide';
          return;
        }

        this.codeValid = true;
        this.promoCampaign = { ...r.data, code: this.promoCode };
        this.$store.commit('setPromoCampaign', this.promoCampaign);
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>
